import type { IIcon } from '@wfp/ui/src/types/utils';
import React from 'react';
import { type WarningEventComment } from '../../../restapi/types';
import { formatDateTimeLocalTZ } from '../../../utils/utils';

export enum CommentsStatus {
	none = 10,
	open = 20,
	done = 30,
}

export const commentsStatusLabel = {
	[CommentsStatus.none]: 'No comment',
	[CommentsStatus.open]: 'Open comment',
	[CommentsStatus.done]: 'Solved comment',
};

export const commentsStatusColor = {
	[CommentsStatus.none]: '#0002',
	[CommentsStatus.open]: '#c5192d',
	[CommentsStatus.done]: '#008868',
};

export const commentsStatusBtnClass = {
	[CommentsStatus.none]: 'comment-btn comment-btn-none',
	[CommentsStatus.open]: 'comment-btn comment-btn-open',
	[CommentsStatus.done]: 'comment-btn comment-btn-done',
};

const iconComment = <svg width="16" height="16" viewBox="0 0 16 16">
	<path
		d="M4 0C1.79086 0 0 1.79086 0 4V8V10V16L4 14H12C14.2091 14 16 12.2091 16 10V8V4C16 1.79086 14.2091 0 12 0H4Z"/>
</svg> as unknown as IIcon;

const iconCommentOpen = <svg width="16" height="16" viewBox="0 0 16 16">
	<path
		d="M4 0C1.79086 0 0 1.79086 0 4V8V10V16L4 14H12C14.2091 14 16 12.2091 16 10V8V4C16 1.79086 14.2091 0 12 0H4Z"/>
	<rect x="7" y="3" width="2" height="5" fill="white"/>
	<rect x="7" y="9" width="2" height="2" fill="white"/>
</svg> as unknown as IIcon;

const iconCommentDone = <svg width="16" height="16" viewBox="0 0 16 16">
	<path
		d="M4 0C1.79086 0 0 1.79086 0 4V8V10V16L4 14H12C14.2091 14 16 12.2091 16 10V8V4C16 1.79086 14.2091 0 12 0H4Z"/>
	<path d="M11.6825 3L13.2171 4.53461L6.75172 11L3 7.24828L4.53461 5.71367L6.75172 7.93078L11.6825 3Z" fill="white"/>
</svg> as unknown as IIcon;

export const commentsStatusIcon = {
	[CommentsStatus.none]: iconComment,
	[CommentsStatus.open]: iconCommentOpen,
	[CommentsStatus.done]: iconCommentDone,
};


export function messageWithHeader(comment: WarningEventComment) {
	return `<p><em>On ${comment.lastTimestamp ? formatDateTimeLocalTZ(comment.lastTimestamp) : '[unknown date and time]'} ` +
		`user ${comment?.lastUser || '[unknown user]'} wrote:</em></p>` +
		comment.message;
}
